import { Component, Input, OnInit, inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { NotificationSettingsService } from "@app/mailmessages/service/notification-settings.service";
import { TabModel } from "@models/generic/TabModels/TabModel";
import { NotificationSettingsType } from "./notification-settings-type.enum";
import { firstValueFrom } from "rxjs";
import { CerrixLoaderComponent } from "@app/shared/components/cerrix-loader/cerrix-loader.component";
import { CerrixTextfieldComponent } from "@app/shared/components/cerrix-textinput/cerrix-textfield/cerrix-textfield.component";
import { TranslatePipe, injectTranslation, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/mailmessages/i18n/scope";

@Component({
    selector: "notification-settings",
    templateUrl: "./notification-settings.component.html",
    styleUrls: ["./notification-settings.component.scss"],
    imports: [FormsModule, CerrixLoaderComponent, CerrixTextfieldComponent, TranslatePipe],
    viewProviders: [provideTranslationScope(scope)],
})
export class NotificationSettingsComponent implements OnInit {
    private settingsService = inject(NotificationSettingsService);
    private toastr = inject(ToastrService);
    private _translation = injectTranslation(scope);

    @Input() parentTab: TabModel;
    slackToken: string;

    async ngOnInit() {
        if (!this.parentTab.showLoader) {
            this.parentTab.showLoader = true;
        }

        const settings = await firstValueFrom(this.settingsService.getSettings());

        settings.forEach((setting) => {
            switch (setting.Type) {
                case NotificationSettingsType.SlackToken: // Slack Token
                    this.slackToken = setting.Value;
                    break;
            }
        });

        this.parentTab.showLoader = false;
    }

    async saveSettings() {
        if (!this.parentTab.showLoader) {
            this.parentTab.showLoader = true;
        }

        const settings = [
            {
                Type: NotificationSettingsType.SlackToken,
                Value: this.slackToken,
            },
        ];

        await Promise.all([
            firstValueFrom(this.settingsService.storeSettings(settings)),
            this._translation.ready(),
        ]);

        this.toastr.success(this._translation.t("settings.settingsSaved"));
        this.parentTab.showLoader = false;
    }

    async syncAllUsers() {
        await Promise.all([
            firstValueFrom(this.settingsService.syncAllUsers()),
            this._translation.ready(),
        ]);
        this.toastr.success(this._translation.t("settings.usersSynced"));
    }
}
